import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 4726",
  "use": "icon-Group 4726-usage",
  "viewBox": "0 0 22.314 22.314",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.314 22.314\" id=\"icon-Group 4726\">\n  <g id=\"icon-Group 4726_Group_4726\" data-name=\"Group 4726\" transform=\"translate(-1184 -136)\">\n    <g id=\"icon-Group 4726_facebook\" transform=\"translate(1184 136)\">\n      <g id=\"icon-Group 4726_Group_4083\" data-name=\"Group 4083\">\n        <path id=\"icon-Group 4726_Path_2519\" data-name=\"Path 2519\" d=\"M11.157,0A11.157,11.157,0,1,0,22.314,11.157,11.17,11.17,0,0,0,11.157,0Zm2.775,11.55H12.117v6.47H9.427V11.55H8.148V9.263H9.427V7.784A2.523,2.523,0,0,1,12.141,5.07l1.993.008V7.3H12.688a.548.548,0,0,0-.57.623V9.264h2.049Z\" fill=\"#fff\" />\n      </g>\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 4726.svg
// module id = m9XZ
// module chunks = 3